<ng-container *ngIf="!loading">
  <svg-icon [name]="name" [style.color]="color"></svg-icon>
</ng-container>

<ng-container *ngIf="loading">
  <svg-icon [name]="'progress-bar'" [style.color]="'#18A0FB'" class="spinning-el" style="width: 24px; height: 24px"></svg-icon>
</ng-container>
